import { Box } from '@mui/material';

interface ISpinningLogoProps {
  size?: number;
}

export const SpinningLogo: React.FC<ISpinningLogoProps> = ({ size = 72 }) => {
  return (
    <Box
      component="img"
      src="/img/torqsiac-loading.png"
      alt="Carregando"
      loading="eager"
      sx={{
        width: size,
        height: size,
        filter: 'brightness(0) invert(1)',
        animation: 'siac-loading-spin 3s linear infinite',
        '@keyframes siac-loading-spin': {
          from: { transform: 'rotate(0deg)' },
          to: { transform: 'rotate(360deg)' },
        },
      }}
    />
  );
};
